import { boolean, nullable, object, optional, string, trimmed } from 'superstruct';
import { email, password } from '@arc/shared/util-superstruct';
export const EditUserDto = object({
  name: optional(trimmed(string())),
  phone: optional(nullable(string())),
  email: optional(email()),
  password: optional(password()),
  archived: optional(boolean()),
  superuser: optional(boolean())
});